import { IPageData, PagesLabels, PagesTypes } from './Routes.interfaces';

export const pages: { [key in PagesTypes]: IPageData } = {
  [PagesTypes.PROFILE]: {
    title: PagesTypes.PROFILE,
    label: PagesLabels.PROFILE,
    path: '/',
  },
  [PagesTypes.AUTH]: {
    title: PagesTypes.AUTH,
    path: '/auth',
    label: PagesLabels.AUTH,
  },
  [PagesTypes.DOC]: {
    title: PagesTypes.DOC,
    path: '/documents',
    label: PagesLabels.DOC,
  },
  [PagesTypes.ORDERS]: {
    title: PagesTypes.ORDERS,
    path: '/orders',
    label: PagesLabels.ORDERS,
  },

  [PagesTypes.SUPPORT_CHAT]: {
    title: PagesTypes.SUPPORT_CHAT,
    path: '/support-chat',
    label: PagesLabels.SUPPORT_CHAT,
  },
};
